import React, { useState } from "react";

import ListTable from "components/scribe/listTable";
import { Modal } from "@mui/material";

const SearchDictationModal = ({ results, onClose }) => {
  const [currentPlaying, setCurrentPlaying] = useState(null);
  return (
    <Modal onClose={onClose} open={true}>
      <div className="search-dictation-modal">
        <h4 className="sdm-title">Results</h4>
        <ListTable
          records={results}
          currentPlaying={currentPlaying}
          setCurrentPlaying={setCurrentPlaying}
        />
      </div>
    </Modal>
  );
};

export default SearchDictationModal;
